/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamTypeListEditorViewModel } from "../types/ExamTypeListEditorViewModel.ts";
import { examTypeListValueEditorViewModelSchema } from "./examTypeListValueEditorViewModelSchema.ts";

export const examTypeListEditorViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
  isInternal: z.optional(z.boolean()),
  examTypeListValues: z
    .array(z.lazy(() => examTypeListValueEditorViewModelSchema))
    .nullish(),
}) as unknown as ToZod<ExamTypeListEditorViewModel>;
